import { Box, Popover, TextField } from "@mui/material";
import React from "react";

import { usePopupState } from "@/shared/hooks";

export interface DevicesTableFilterPopoverProps {
  popup: ReturnType<typeof usePopupState<void>>;
  filter: string;
  onFilterApply: (filter: string) => void;
  placeholder: string;
}

export const DevicesTableFilterPopover: React.FC<
  DevicesTableFilterPopoverProps
> = ({ popup, filter, onFilterApply, placeholder }) => {
  const [localValue, setLocalValue] = React.useState(filter);

  // Update local value when filter prop changes (e.g., when cleared externally)
  React.useEffect(() => {
    setLocalValue(filter);
  }, [filter]);

  // Reset local value when popover opens
  React.useEffect(() => {
    if (popup.isOpen) {
      setLocalValue(filter);
    }
  }, [popup.isOpen, filter]);

  return (
    <Popover
      disableRestoreFocus
      disableAutoFocus
      open={popup.isOpen}
      anchorEl={popup.anchor}
      onClose={() => popup.close()}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <Box sx={{ p: 2, minWidth: 200 }}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            onFilterApply(localValue);
            popup.close();
          }}
        >
          <TextField
            autoFocus
            fullWidth
            size="small"
            placeholder={placeholder}
            variant="outlined"
            value={localValue}
            onChange={(event) => {
              setLocalValue(event.target.value);
            }}
          />
        </form>
      </Box>
    </Popover>
  );
};
